import {
  useDeleteApprovalFavoriteFilter,
  useGetApprovalFavoriteFilter,
  useModifyFavoriteFilter,
  useSetApprovalFavoriteFilter,
} from '@/hooks/apiHooks';
import {
  FavoriteApprovalFilter,
  FavoriteFilter,
  FavoriteFilterData,
} from '@/types/api';
import { useAtom } from 'jotai';
import { approvalFilter } from '@/recoil/atom';

const useFavoriteApproval = () => {
  const { data: favoriteData, mutate } = useGetApprovalFavoriteFilter();
  const [filters, setFilters] = useAtom(approvalFilter);

  const handleDelete = async (id: string) => {
    useDeleteApprovalFavoriteFilter(id).then(() => {
      // 🔥 2️⃣ 삭제된 데이터를 반영하여 UI 즉시 업데이트
      mutate(
        {
          ...favoriteData,
          data: favoriteData?.data.filter((item) => item.id !== id),
        },
        false,
      );
    });
  };

  const handleSet = (obj: FavoriteFilter) =>
    useSetApprovalFavoriteFilter(obj).then(() =>
      mutate((current: any) => {
        if (!current) return current;

        return favoriteSort(current);
      }),
    );

  const favoriteSort = (obj?: FavoriteApprovalFilter) => {
    if (!obj) return obj;
    const sorted = [...obj.data].sort((a, b) => a.name.localeCompare(b.name));
    return { ...obj, data: sorted };
  };

  const handleModify = ({ name, id }: FavoriteFilter & { id: string }) =>
    useModifyFavoriteFilter({ id: id, name: name }).then(() =>
      mutate((currentData: any) => {
        if (!currentData) return currentData;
        const isCurrentFilter = filters.id === id;
        isCurrentFilter && setFilters({ ...filters, filterName: name });
        return {
          ...currentData,
          data: currentData.data.map((item: FavoriteFilterData) =>
            item.id === id ? { ...item, name: name } : item,
          ),
        };
      }, false),
    );

  return {
    data: favoriteSort(favoriteData),
    handleDelete,
    handleSet,
    handleModify,
  };
};

export default useFavoriteApproval;
